// extracted by mini-css-extract-plugin
export default {"section":"Projects_section__CwynR","type_project":"Projects_type_project__RFmtw","list_projects":"Projects_list_projects__gpDEh"};